import { render, staticRenderFns } from "./Reservasi.vue?vue&type=template&id=d08f2e34&scoped=true"
import script from "./Reservasi.vue?vue&type=script&lang=js"
export * from "./Reservasi.vue?vue&type=script&lang=js"
import style0 from "./Reservasi.vue?vue&type=style&index=0&id=d08f2e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08f2e34",
  null
  
)

export default component.exports